import { TidewaysContext } from '../app/context'
import Range from '../app/timeRange'
import { RangeSelectorInterface } from './RangeSelectorInterface'

export const rangeSelectorPerformanceView = (tidewaysContext: TidewaysContext, navigator): RangeSelectorInterface => ({
    setDuration: duration => {
        tidewaysContext.getRange().setDuration('PT' + duration + 'M')

        navigator.replace({ ...tidewaysContext.toParameters() })
    },
    setStartEnd: (start, end) => {
        tidewaysContext.setRange(Range.fromStartAndEnd(start, end).limitRange(60, 60 * 24))

        const route = redirectRouteOnRangeSelect[tidewaysContext.route.route]
            ? redirectRouteOnRangeSelect[tidewaysContext.route.route]
            : tidewaysContext.route.route

        // reset selected events/error on rangeSelect
        navigator.replace(
            {
                ...tidewaysContext.toParameters(),
                events: null,
                event: null,
                error: null,
                date: null, // snapshot
                end: null, // snapshot
            },
            route,
        )
    },
    setService: service => {
        tidewaysContext.setService(service)
        updateRoute(tidewaysContext, navigator)
    },
    setEnvironment: environment => {
        tidewaysContext.setEnvironment(environment)
        updateRoute(tidewaysContext, navigator)
    },
    active: duration => duration === tidewaysContext.getRange().asMinutes(),
    last: () => {
        tidewaysContext.getRange().setEndDate(null)

        navigator.replace({ ...tidewaysContext.toParameters() })
    },
    move: direction => {
        // @ts-ignore
        const range: Range = direction === 'next' ? tidewaysContext.getRange().getNext() : tidewaysContext.getRange().getPrevious()

        tidewaysContext.setRange(range)

        navigator.replace({ ...tidewaysContext.toParameters() })
    },
    isLast: () => tidewaysContext.getRange().isCurrent(),
    supportsLiveData: true,
    supportsGraph: () => tidewaysContext.isProductionEnvironment() && tidewaysContext.application.license.timeExplorer,
    getRange: () => tidewaysContext.getRange(),
    ranges: [
        { label: '60 minutes', value: 60 },
        { label: '3 hours', value: 180 },
        { label: '12 hours', value: 720 },
        { label: '24 hours', value: 1440 },
    ],
})

const redirectRouteOnRangeSelect = {
    'XhprofProfilerBundle.Snapshot.show': 'XhprofOrganizationBundle.Application.show',
    'XhprofProfilerBundle.OperationSnapshot.show': 'XhprofProfilerBundle.Transaction.show',
}

const operationRoutes = ['XhprofProfilerBundle.Transaction.show', 'XhprofProfilerBundle.OperationSnapshot.show']

const updateRoute = (tidewaysContext: TidewaysContext, navigator) => {
    let route =
        operationRoutes.indexOf(tidewaysContext.route.route) !== -1
            ? 'XhprofOrganizationBundle.Application.show'
            : tidewaysContext.route.route

    if (route in redirectRouteOnRangeSelect) {
        route = redirectRouteOnRangeSelect[route]
    }

    navigator.replace(
        {
            ...tidewaysContext.toParameters(),
            operation: null,
            date: null, // snapshot
            end: null, // snapshot
            event: null,
            events: null,
            error: null,
        },
        route,
    )
}
